export default __webpack_public_path__ + "static/media/penni.c59d669d.png";